<template>
    <div class="container">
        <PageHero v-bind="heroData" />
        <section class="my-4 pt-4 lg:my-6 lg:pt-0">
            <component
                :is="FaqSections"
                v-bind="
                    data.components?.find(
                        (comp): comp is FaqSectionsComponentModel => comp.alias === 'faqSections'
                    )
                " />
        </section>
    </div>
</template>
<script setup lang="ts">
import type {
    BaseContentResponseModel,
    FaqSectionsComponentModel,
    HeroComponentModel,
} from '@su4r-frontend/api';
import FaqSections from '../faq/FaqSections.vue';

const { data } = defineProps<{
    data: BaseContentResponseModel;
}>();

const heroData = data.components?.find(
    (comp): comp is HeroComponentModel => comp.alias === 'heroComponent'
);
</script>
